import React, { useState, useEffect, useContext } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },

  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const CountryMFSMapperAddEdit = ({ list, setList, countryList, selectedBankId, closeAddDialog, addDialog }) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [loading, setLoading] = useState(false);

  const [countryId, setCountryId] = useState('');
  const [mfsId, setMfsId] = useState('');
  const [mfsList, setMfsList] = useState([]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const validation = () => {
    let isError = false;
    if (!countryId.trim()) {
      console.log('countryId');
      handleSnakbarOpen('Please select country name', 'error');
      document.getElementById('countryId').focus();
      return (isError = true);
    }
    if (!mfsId.trim()) {
      handleSnakbarOpen('Please select MFS name', 'error');
      document.getElementById('mfsId').focus();
      return (isError = true);
    }

    console.log('finish');
    return isError;
  };

  const handleChange = event => {
    setCountryId(event.target.value);
  };
  const handleMFSChange = event => {
    setMfsId(event.target.value);
  };

  const clearStates = () => {
    setCountryId('');
    setMfsId('');
  };

  const onSubmit = async e => {
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      try {
        response = await axios({
          url: `/api/v1/private/country/${countryId}/mfs/${mfsId}`,
          method: 'post',
          data: { countryId, mfsId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (selectedBankId === countryId) {
          setList([...list, response.data.data]);
        }
        clearStates();
        console.log('response', response);
        console.log('addForm Submit', countryId, mfsId);

        closeAddDialog();
        // activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
  };

  const getMFS = async () => {
    await axios
      .get(`/api/v1/public/mfs`)
      .then(function(response) {
        console.log('response', response);
        setMfsList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };

  useEffect(() => {
    getMFS();
  }, []);

  // useEffect(() => {
  //   if (addDialog === false) {
  //     activeAddForm();
  //   }
  // }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          Add Country MFS Mapper
        </Typography>
      </div> */}

      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              // activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {/* {editForm ? 'Update Person' : 'Add Person'} */}
          Add Country MFS Mapper
        </Typography>
      </div>

      <FormControl variant="outlined" size="small" fullWidth className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="demo-simple-select-outlined-label">Select Country</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="countryId"
          value={countryId}
          onChange={handleChange}
          label="Select Country">
          {countryList &&
            countryList.map((item, i) => (
              <MenuItem value={item.id} key={i}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" fullWidth size="small" className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="demo-simple-select-outlined-label">Select MFS</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="mfsId"
          value={mfsId}
          onChange={handleMFSChange}
          label="Select MFS">
          {mfsList &&
            mfsList.map((item, i) => (
              <MenuItem key={i} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          Save
        </Button>
      </div> */}
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {/* {editForm ? 'Update' : 'Save'} */}
          Save
        </Button>
      </div>
    </React.Fragment>
  );
};

export default CountryMFSMapperAddEdit;
